import React, { CSSProperties } from 'react';
import { useRef, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../../Core/hooks';
import { getRoadmap } from '../../Store/Roadmap';
import { getSettings } from '../../Store/Settings';
import { getProject } from '../../Store/Project';
//import Footer from '../../Components/Footer';
//import Navigation from '../../Components/Navigation';
import SubNav from '../SubNav';
import TopNav from './TopNav';
import LeftNav from '../Mobile/LeftNav';
import LeftSubNav from '../LeftSubNav';
import Main from '../Main';
import RoadmapMain from '../RoadmapMain';
import RoadmapMember from '../RoadmapMember';
import RoadmapSubNav from '../RoadmapSubNav';
import Redirect from '../Redirect';
import Settings from '../Settings';
import WorkBoard from '../WorkBoard';
import ChatSubNav from '../ChatSubNav';
import ChatMain from '../ChatMain';
import RoadmapDash from '../RoadmapDash';


function Dash() {

  const roadmapState = useAppSelector(getRoadmap);
  const projectState = useAppSelector(getProject);
  const settingsState = useAppSelector(getSettings);
  const roadmap = roadmapState.roadmaps.find(r => r.loaded);
  const project = projectState.projects.find(p => p.loaded);
  const settings = settingsState.settings;

  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;
  
    if (settingsState.settings.loadedComponentType === "chat") {
      // Scroll to bottom for chat
      container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
    } else {
      // Scroll to top for all others
      container.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [settingsState.settings.loadedComponentType]);
  

  //const { pathname } = useLocation();
  //const scrollRef = useRef<HTMLDivElement>(null);
/*
  useEffect(() => {
    scrollRef.current?.scrollTo(0, 0);
  }, [pathname]); 
  */
 /*
  let mainStyle: CSSProperties = { display: "inline-block" };
  //mainStyle.backgroundColor="red";
  //mainStyle.height = "80vh";
  if (settingsState.settings.loadedComponentType === "global_herdr") {
    //{ display: "inline-block", width: "70%" }
    mainStyle.width = "100%";
  } else {
    if (settingsState.settings.sidebarExpanded) {
      //if (settingsState.settings.chatExpanded) {
      //  mainStyle.width = "55%";
      //} else {
      if (settingsState.settings.loadedComponentType === "chat") {
        mainStyle.width = "70%"; // 70
      } else {
        mainStyle.width = "77%";
      }
    } else {
      mainStyle.width = "100%";
    }
  }
*/
  if (settingsState.settings.loadedComponentType === "") 
    return (
      <>
        <Redirect />
        <div style={{ width: "100%", margin: "0px auto", paddingTop: "100px", textAlign: "center" }}>
          <div>
              <img style={{ width: "125px"}} src="/images/herdr-orange-logo-cat-v1.png" alt="herdr.io" />
          </div>
          <div style={{ fontStyle: "italic", fontSize: "28pt" }}>Loading...</div>
        </div>
      </>
    );

    let loadedComponent = (settingsState.status !== "loadingComponent") ? <Main /> : <div />;
    
    if (settings.loadedComponentType === "global_herdr") {
        loadedComponent = <Settings />;
    } else if (settings.loadedComponentType === "roadmap") {
      //let roadmap = roadmapState.roadmaps.find(r => r.loaded);
      if (roadmap) {
        if (roadmap.mode === "roadmap") {
          loadedComponent = <RoadmapMain roadmap={roadmap} />;
          //console.log("loadedComponent: " + loadedComponent);
        //} else if (roadmap.mode === "generate") {
        //  loadedComponent = <RoadmapGenerate roadmap={roadmap} />;
        } else if (roadmap.mode === "dashboard") {
          loadedComponent = <RoadmapDash roadmap={roadmap} />;
        } else if (roadmap.mode === "members") {
          loadedComponent = <RoadmapMember roadmap={roadmap} />;
        //} else if (roadmap.mode === "settings") {
        //  loadedComponent = <RoadmapSettings roadmap={roadmap} />;
        }
      }
    } else if (settings.loadedComponentType === "work") {
      //let project = projectState.roadmaps.find(r => r.loaded);
      if (project) {
        //if (project.mode === "calendar") {
        //  loadedComponent = <WorkCalendar project={project} />;
        if (project.mode === "board") {
          loadedComponent = <WorkBoard project={project} />;
        //} else if (project.mode === "list") {
          //loadedComponent = <WorkList project={project} />;
        //} else if (project.mode === "members") {
        //  loadedComponent = <WorkMember project={project} />;
        }
      }
    } else if (settings.loadedComponentType === "chat") {
      loadedComponent = <ChatMain />;
    }

  return (
    <>
      <Redirect />

        {/*
        <div style={{ display: "inline-block", width: ".5%" }}></div>
        {settingsState.settings.sidebarExpanded &&
          <>
            {(settingsState.settings.loadedComponentType === "roadmap" ||
            settingsState.settings.loadedComponentType === "work") &&
              <div style={{ display: "inline-block", width: "18%" }}>
                <LeftSubNav roadmap={roadmap} project={project} />
              </div>
            }
            {settingsState.settings.loadedComponentType === "global_maps" &&
              <div style={{ display: "inline-block", width: "18%" }}>
                <RoadmapSubNav />
              </div>
            }
            {settingsState.settings.loadedComponentType === "chat" &&
              <div style={{ display: "inline-block", width: "25%" }}>
                <ChatSubNav />
              </div>
            }
            {settingsState.settings.loadedComponentType !== "global_herdr" &&
              <div style={{ display: "inline-block", width: "10px", backgroundColor: "#02152a", height: "100vh" }}></div>
            }
          </>
        }
        */}

        <div ref={scrollContainerRef}
        style={{
            overflowX: 'auto',
            whiteSpace: 'nowrap',
            height: 'calc(100vh - 60px)'    
        }}>
        
          <TopNav />
          {/*<SubNav />*/}
          {loadedComponent}
          
        </div>

        {/*<div style={{ display: "inline-block", width: ".5%" }}></div>*/}
 
      <LeftNav />
    </>
  );
}

export default Dash;